import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Grid, LockIcon, useResponsive } from '@common-fe/common-fe';

import ProfileSettingCard from '@/modules/user/components/ManageProfile/components/ProfileSettingCard/ProfileSettingCard';

import ChangePasswordModal from './components/ChangePasswordModal/ChangePasswordModal';

const Security = () => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  const [isChangePasswordModalVisible, setIssChangePasswordModalVisible] = useState(false);

  const handleOpenChangePasswordModal = useCallback(() => {
    setIssChangePasswordModalVisible(true);
  }, []);

  return (
    <>
      <Box round="moduleRound" pad={isMobile ? 'spacing16' : 'spacing24'} background="module">
        <Grid columns={isMobile ? ['1fr'] : ['1fr', '1fr']} gap="spacing24">
          <ProfileSettingCard
            testId="password"
            icon={<LockIcon size="60px" color="textDisabled" />}
            title="Password"
            isMobileSettingProperty
            description={t('Keep your account secure')}
            settingPropertyName={t('Change')}
            onChangeSettingProperty={handleOpenChangePasswordModal}
          />
        </Grid>
      </Box>

      {isChangePasswordModalVisible && (
        <ChangePasswordModal onSetVisible={setIssChangePasswordModalVisible} />
      )}
    </>
  );
};

export default Security;
